export const theme = {
    primaryDark: '#0D0C1D',
    primaryLight: 'rgba(162,162,162,0.94)',
    primaryHover: '#343078',
    mobile: '10px',
}
